"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subtitleMapping = exports.productTypes = exports.prodTypeMapping = exports.headers = exports.AjaxStatus = void 0;
var AjaxStatus = exports.AjaxStatus = {
  Initial: 0,
  InProgress: 1,
  Success: 2,
  Error: 3
};

/*
  This does not exist in the API. We may request the backend to add this.
  For now, we can hardcode this here. We just have to add more product mappings.
*/
var subtitleMapping = exports.subtitleMapping = new Map([['LC_FIXED_RATE_PLAN', 'Fixed Rate, Equal Payment Required'], ['PROMOTIONAL_RATE_PLAN', 'Low APR, Equal Payment Required'], ['INTEREST_FREE_LOAN', 'Waived Interest, Payment Required'], ['LC_TRUE_NO_INTEREST', 'Fixed Rate, Equal Payment Required']]);
var productTypes = exports.productTypes = {
  LCFRP: 'LCFRP',
  PRP: 'PRP',
  LCTNI: 'LCTNI',
  NI: 'NI'
};
var prodTypeMapping = exports.prodTypeMapping = new Map([[productTypes.LCFRP, 'LC_FRP'], [productTypes.PRP, 'PRP'], [productTypes.LCTNI, 'LC_TNI'], [productTypes.NI, 'IF']]);
var headers = exports.headers = {
  SUCCESS: {
    title: 'Congratulations!',
    subtitle: 'You prequalify for the following options. Select an option that best suits your needs.'
  },
  FULL_DECLINE: {
    title: 'We’re sorry.',
    subtitle: 'We are unable to present you with offers at this time. You will receive further information regarding your request for financing at the address provided on your application.',
    description: 'Due to privacy reasons, our Customer Care team does not have access to the reason(s) behind this decision. If the patient is in need of immediate financing, another person may apply on their behalf.'
  },
  ADS_HARD_PULL_DECLINE: {
    title: 'We’re sorry.',
    subtitle: 'The option you selected is no longer available. Unfortunately, Comenity Capital Bank is unable to offer you any plan options at this time. Further information will be provided via mail.',
    description: 'We are, however, happy to be able to offer you the following options instead.'
  },
  ADS_HARD_PULL_COUNTER: {
    title: 'You qualify for the following options.',
    subtitle: 'You now have a credit account with Comenity Capital Bank with a credit limit of ',
    description: 'Although you did not qualify for the full requested amount, you still qualify for this other amount. You can either use this account for the Promotional Rate Plan, or choose a Fixed Rate Plan instead. If you would like to close your account with Comenity Capital Bank, please contact the bank directly at 1-866-954-9258 (TDD/TTY: 1-888-819-1918).'
  },
  DECLINE_FROZEN: {
    title: 'We’re sorry.',
    subtitle: "We were unable to process this application because there is a freeze on the applicant's credit file. Please contact Experian at (888) 397-3742 and TransUnion at (888) 909-8872 to temporarily lift the freeze. If there is a freeze on both credit bureaus, then the applicant will need to contact Experian and TransUnion. They will then need to call us directly to re-apply with LendingClub Patient Solutions."
  }
};
